import React from 'react';

import { SegmentedControl } from '@ajaibid/components';

import { useStockBuySellContext } from '../../hooks';
import { useEventTracker } from '../../../tracker';

const SwitchOrderSide = () => {
  const { code, formState, formKey, formAction, dispatch } = useStockBuySellContext();
  const { eventClickSwitchOrderSide } = useEventTracker();

  const onChangeOrderSide = (v) => {
    dispatch({ type: formAction.CHANGE_ORDER_SIDE, code, payload: v?.value });
    eventClickSwitchOrderSide({ orderSide: v?.value });
  };

  return (
    <SegmentedControl
      block
      variant="buy-sell"
      value={formState[formKey.INPUT_ORDER_SIDE]}
      onChange={onChangeOrderSide}
      data-testid="switch-orderSide"
    />
  );
};

export default SwitchOrderSide;
